import React from "react";
import { useAllReservationContext } from "../context/AllReservationContext/AllReservationContext";

import { ReservationsDateRange } from "./ReservationsDateRange";
import { Button } from "../../../shared/Button/Button";
import { AdjustableButtons } from "../../../shared/AdjustableButtons/AdjustableButtons";
import { AllReservationWorkspacePicker } from "./AllReservationWorkspacePicker";

export const AllReservationsHeaderButtons = () => {
  const { openWorkspacePicker, setOpenWorkspacePicker } =
    useAllReservationContext();

  return (
    <>
      {openWorkspacePicker && (
        <>
          <AllReservationWorkspacePicker />
          <div
            onClick={() => setOpenWorkspacePicker(false)}
            className="background__shadow position-fixed"
          ></div>
        </>
      )}
      <div className="flex-a-center gap-1">
        <AdjustableButtons>
          <ReservationsDateRange />

          <Button
            title="Select calendars"
            color="third"
            size="medium"
            onClick={() => {
              if (!openWorkspacePicker) {
                setOpenWorkspacePicker(true);
              }
            }}
            icon="eye-default"
            className="CalendarSelector"
          />
        </AdjustableButtons>
      </div>
    </>
  );
};
